import * as React from 'react';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { assertNever } from '@kofno/piper';

import IframeContentStore from './Store';
import Loader from '../../../../../../Loader';
import { findLink } from '../../../../../../../LinkyLinky';

interface Props {
  store: IframeContentStore;
}

const IframeContent: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'loading':
      return (
        <div className="h-[calc(100%-80px)] w-full bg-gray-200 opacity-50">
          <Loader type="spin" text={just('loading participant preview...')} className="h-full" />
        </div>
      );
    case 'ready':
      return findLink('preview-learning-collection', store.links)
        .map((link) => {
          return (
            <div className="h-[calc(100%-80px)] w-full overflow-auto">
              <iframe
                className="h-full w-full"
                src={link.href}
                title="Learning Collection Preview"
              />
            </div>
          );
        })
        .getOrElse(() => <></>);

    default:
      assertNever(store.state);
  }
};

export default observer(IframeContent);
